import React, { useContext, useEffect, useState } from 'react';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import { ScreensContext } from '../contexts/screensContext';
import NewReviewFlowScreen from '../common/new-review-flow-screen';
import ResultComponent from '../common/new-review-flow-screen/components/result-component';

const NewReviewFlowTest = () => {
  const [isAlreadyUsed, setIsAlreadyUsed] = useState(false);
  const [flowKey, setFlowKey] = useState(0);
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);

  const { init } = useContext(DataLayerEventContext);

  useEffect(() => {
    init('new-review-flow-test');
  }, [init]);

  const restartFlow = () => {
    setIsAlreadyUsed(false);
    setFlowKey((prev) => prev + 1);
  };

  return (
    <ScreensContext.Provider
      value={{
        endSessionType,
        setEndSessionType,
        isDisplayedAll,
        setIsDisplayedAll
      }}
    >
      {isAlreadyUsed ? (
        <ResultComponent setScreenNumber={restartFlow} isSuccess={false} />
      ) : (
        <NewReviewFlowScreen key={flowKey} setScreenNumber={restartFlow} />
      )}
      <button
        onClick={() => {
          setIsAlreadyUsed(!isAlreadyUsed);
          setFlowKey((prev) => prev + 1);
        }}
        style={{
          position: 'fixed',
          right: 8,
          bottom: 8,
          zIndex: 1000,
          padding: '6px 10px',
          borderRadius: 6,
          border: '1px solid rgba(255,255,255,.4)',
          background: 'rgba(0,0,0,.45)',
          color: '#fff',
          fontSize: 11
        }}
      >
        {isAlreadyUsed ? '← флоу' : '«Дякуємо!» →'}
      </button>
    </ScreensContext.Provider>
  );
};

export default NewReviewFlowTest;
